
export const products = {
  'product.categories': '製品カテゴリ',
  'explore.solutions': '当社の包括的なプロフェッショナルAVソリューションをご覧ください',
  'view.video': '製品概要ビデオを見る',
  'AV Over IP': 'IP経由のAV',
  'ReAX Control': 'ReAXコントロール',
  'Meeting Room Solutions': '会議室ソリューション',
  'Converters/Scalers': 'コンバーター/スケーラー',
  'Audio Products': 'オーディオ製品',
  'HDMI Switchers': 'HDMIスイッチャー',
  'IPBaseT': 'IPBaseT',
  'HDBaseT Products': 'HDBaseT製品',
  'Complete AV distribution solution with ultra-low latency': '超低遅延の完全なAV配信ソリューション',
  'Professional control system solutions': 'プロフェッショナルな制御システムソリューション',
  'Complete solutions for modern meeting spaces': '現代の会議スペース向けの完全なソリューション',
  'Professional format conversion and scaling solutions': 'プロフェッショナルなフォーマット変換とスケーリングのソリューション',
  'Professional audio processing and playback solutions': 'プロフェッショナルな音声処理と再生のソリューション',
  'Professional HDMI switching and distribution solutions': 'プロフェッショナルなHDMI切り替えと配信のソリューション',
  'Advanced IP-based AV distribution platform': '先進的なIPベースのAV配信プラットフォーム',
  'Professional HDBaseT distribution solutions': 'プロフェッショナルなHDBaseT配信ソリューション',
  'group.not.found': 'グループが見つかりません',
  'product.not.found': '製品が見つかりません',
  'return.to.home': 'ホームページに戻る',
  'back.to.product.group': '製品グループに戻る',
  'overview': '概要',
  'full.description': '詳細説明',
  'features': '機能',
  'specifications': '仕様',
};
